<template>
  <div>
    <div style="display: flex; justify-content: flex-start; align-items: center; flex-direction: row; margin-bottom: 10px;">
      <el-button size="small" @click="openAddDialog" type="primary">
        {{ $t("message.dataWedge.NewConfigurationAdd") }}
      </el-button>
      <div>
        <span style="color: red;font-size: 12px;">{{ $t("message.dataWedge.dataTips") }}</span>
      </div>
    </div>
    <el-tabs v-model="editableTabsValue" type="card" @tab-remove="removeTab">
      <!-- =======设置页面 ======-->
      <el-tab-pane :label="$t('message.dataWedge.data_wedge_set')">
        <set-data-wedge :dataWedgeSetting="dataWedgeApp"></set-data-wedge>
      </el-tab-pane>
      <!-- =====设置页面end===== -->
      <el-tab-pane v-for="(item, index) in editableTabs" :key="index" :label="item.title" :name="item.name"
        :closable="item.title !== 'Default' && item.title !== 'Scan Demo'" :deleteAllData='deleteAllData'
        @allDataDeleted="allDataDeleted">
        <scan-component :scanData="item.content" :comtitle="item.title" :deleteAllData='deleteAllData' ref="scanDemo"
          v-if="item.title === 'Scan Demo'"></scan-component>
        <dw-component ref="childComponentRef" :dwData="item.content" :comtitle="item.title" :comIndex="index"
          :comDes="item.description" :tabsValue="editableTabs" :deleteAllData="deleteAllData"
          @allDataDeleted="allDataDeleted" v-else></dw-component>
      </el-tab-pane>
    </el-tabs>

    <!-- 新增配置页 -->
    <el-dialog :title="$t('message.dataWedge.NewProfile')" :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="30%">
      <el-form :model="newTabsItem" :rules="tabsRules" ref="tabsRef">
        <el-form-item :label="$t('message.dataWedge.ProfileName')" :label-width="formLabelWidth" prop="name">
          <el-input v-model="newTabsItem.name" autocomplete="off" :placeholder="$t('message.dataWedge.EnterFileName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('message.dataWedge.ConfigurationFileDescription')" :label-width="formLabelWidth" prop="content">
          <el-input v-model="newTabsItem.content" autocomplete="off" :placeholder="$t('message.dataWedge.EnterDescription')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAddTab">{{ $t("message.dataWedge.cancel") }}</el-button>
        <el-button type="primary" @click="addTab">{{ $t("message.dataWedge.submit") }}</el-button>
      </div>
    </el-dialog>
    <!-- end -->
    <div style="hidden">{{ newTabsItem.name }}</div>
  </div>
</template>

<script>
import DwComponent from "@/views/menuPage/dataWedgeComponents/dwComponent.vue";
import ScanComponent from "@/views/menuPage/dataWedgeComponents/scanComponent.vue";
import SetDataWedge from "@/views/menuPage/dataWedgeComponents/setDataWedge.vue";
import { isEmpty, cloneDeep } from 'lodash';
import { EventBus } from '@/utils/event-bus';
export default {
  props: {
    isCustomPage: { type: Boolean },
  },
  data() {
    const dwComData = {
      title: "Default",
      description: "默认通用参数配置文件",
      floatButton: {},
      relatedApps: {},
      // intent
      intentOutputConfig: {
        advanceFormat: {
          rules: [],
        },
        basicFormat: {
        },
      },
      // ip
      ipOutputConfig: {
        advanceFormat: {
          rules: [],
        },
        basicFormat: {
        },
      },
      // 按键
      keyOutputConfig: {
        advanceFormat: {
          rules: [],
        },
        basicFormat: {
        },
      },
      // 条码
      scanSettings: {
        decoderParamsObjs: {},
      },
    };
    const scanData = {
      title: "Scan Demo",
      description: "Scan Demo参数设置",
      floatButton: {},
      relatedApps: {
        "com.seuic.dwdemo": ["com.seuic.dwdemo*"]
      },
      // intent
      intentOutputConfig: {
        advanceFormat: {
          rules: [],
        },
        basicFormat: {
        },
      },
      // ip
      ipOutputConfig: {
        advanceFormat: {
          rules: [],
        },
        basicFormat: {
        },
      },
      // 条码
      scanSettings: {
        decoderParamsObjs: {},
      },
    };
    const defaultTabs = [
      {
        title: "Default",
        name: "Default",
        description: "默认通用参数配置文件",
        content: dwComData,
      },
      {
        title: "Scan Demo",
        name: "Scan Demo",
        description: "Scan Demo参数设置",
        content: scanData,
      },
    ];
    return {
      dwComData, //default
      scanData, //ScanDemo
      defaultTabs, //
      editableTabsValue: "",
      newTabsItem: {
        name: "",
        content: "",
      },
      editableTabs: [],
      tabIndex: 0,
      formLabelWidth: "150px",
      dialogFormVisible: false,
      tabsRules: {
        name: [
          {
            required: true,
            message: this.$t("message.dataWedge.EnterFileName"),
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("message.dataWedge.EnterDescription"),
            trigger: "blur",
          },
        ],
      },
      //   绑定参数值
      dwComData: {
        title: "Default",
        description: "默认通用参数配置文件",
        floatButton: {},
        relatedApps: {},
        // intent
        intentOutputConfig: {
          advanceFormat: {
            rules: [],
          },
          basicFormat: {
          },
        },
        // ip
        ipOutputConfig: {
          advanceFormat: {
            rules: [],
          },
          basicFormat: {
          },
        },
        // 按键
        keyOutputConfig: {
          advanceFormat: {
            rules: [],
          },
          basicFormat: {
          },
        },
        // 条码
        scanSettings: {
          decoderParamsObjs: {},
        },
      },
      //ScanDemo
      scanData: {
        title: "Scan Demo",
        description: "Scan Demo参数设置",
        floatButton: {},
        relatedApps: {
          "com.seuic.dwdemo": ["com.seuic.dwdemo*"]
        },
        // intent
        intentOutputConfig: {
          advanceFormat: {
            rules: [],
          },
          basicFormat: {
          },
        },
        // ip
        ipOutputConfig: {
          advanceFormat: {
            rules: [],
          },
          basicFormat: {
          },
        },
        // 条码
        scanSettings: {
          decoderParamsObjs: {},
        },
      },
      //   绑定参数值
      dataWedgeApp: {},
      deleteAllData: false
    };
  },
  components: {
    DwComponent,
    ScanComponent,
    SetDataWedge
  },
  watch: {
    editableTabs: {
      handler(val) {
        if (this.editableTabs.length) {
          localStorage.setItem(this.isCustomPage ? "config-editableTabs" : 'editableTabs', JSON.stringify(val));
          if (JSON.stringify(val) !== JSON.stringify(this.defaultTabs)) {
            this.$emit('handleDataWedgeIsApply', true);
          } else {
            this.$emit('handleDataWedgeIsApply', false);
          }
        } else {
          localStorage.removeItem(this.isCustomPage ? 'config-editableTabs' : 'editableTabs');
        }
      },
      deep: true
    },
    dataWedgeApp: {
      handler(val) {
        if (!isEmpty(val)) {
          localStorage.setItem(this.isCustomPage ? "config-dataWedgeApp" : 'dataWedgeApp', JSON.stringify(val));
          if (JSON.stringify(val) !== JSON.stringify(this.dwComData)) {
            this.$emit('handleDataWedgeIsApply', true);
          }
        } else {
          localStorage.removeItem(this.isCustomPage ? 'config-dataWedgeApp' : 'dataWedgeApp');
        }
      },
      deep: true
    }
  },
  methods: {
    // 打开新增弹框
    openAddDialog() {
      this.dialogFormVisible = true;
    },
    // 新增
    addTab() {
      const targetObj = this.editableTabs.find(item => item.name === this.newTabsItem.name);
      if (targetObj) {
        this.$message.error(this.$t('message.dataWedge.alre_ex_name'));
        this.newTabsItem.name = "";
        this.newTabsItem.content = "";
      } else {
        this.$refs["tabsRef"].validate((valid) => {
          if (valid) {
            this.editableTabs.push({
              title: this.newTabsItem.name,
              name: this.newTabsItem.content,
              description: this.newTabsItem.content,
              content: {
                title: this.newTabsItem.name,
                description: this.newTabsItem.content,
                floatButton: {},
                relatedApps: {},
                // intent
                intentOutputConfig: {
                  advanceFormat: {
                    rules: [],
                  },
                  basicFormat: {
                  },
                },
                // ip
                ipOutputConfig: {
                  advanceFormat: {
                    rules: [],
                  },
                  basicFormat: {
                  },
                },
                // 按键
                keyOutputConfig: {
                  advanceFormat: {
                    rules: [],
                  },
                  basicFormat: {
                  },
                },
                // 条码
                scanSettings: {
                  decoderParamsObjs: {},
                },
              }, // 使用新的数据副本
            });
            this.editableTabsValue = this.newTabsItem.name;
            this.dialogFormVisible = false;
            this.$nextTick(() => {
              this.newTabsItem.name = "";
              this.newTabsItem.content = "";
            })
          }
        });
      }
    },
    // 需求新增
    cancelAddTab() {
      this.dialogFormVisible = false;
      this.newTabsItem.name = "";
      this.newTabsItem.content = "";
    },
    // 移除
    removeTab(targetName) {
      this.$confirm("此操作将永久删除该配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let tabs = this.editableTabs;
          let activeName = this.editableTabsValue;
          if (activeName === targetName) {
            tabs.forEach((tab, index) => {
              if (tab.name === targetName) {
                let nextTab = tabs[index + 1] || tabs[index - 1];
                if (nextTab) {
                  activeName = nextTab.name;
                }
              }
            });
          }
          this.editableTabsValue = activeName;
          this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    allDataDeleted() {
      this.deleteAllData = false;
    },
    // 重置
    resetData() {
      this.deleteAllData = true;
      localStorage.removeItem(this.isCustomPage ? "config-editableTabs" : "editableTabs");
      localStorage.removeItem(this.isCustomPage ? "config-dataWedgeApp" : "dataWedgeApp");
      this.$emit('handleDataWedgeIsApply', false);
      this.$nextTick(() => {
        if (this.$refs.scanDemo) {
          this.$refs.scanDemo[0].clearAllData();
        }
      });
      this.initData();
    },
    // 初始化参数
    initData() {
      this.editableTabs = JSON.parse(localStorage.getItem(this.isCustomPage ? "config-editableTabs" : "editableTabs")) || cloneDeep(this.defaultTabs);
      this.editableTabsValue = this.editableTabs[0].name;
      // 
      this.dataWedgeApp = JSON.parse(localStorage.getItem(this.isCustomPage ? "config-dataWedgeApp" : "dataWedgeApp")) || {};
    },
    // 删除子数据
  },
  created() {
    this.initData();
    EventBus.$on('clearDWdata', () => {
      this.resetData();
    })
  },
  beforeDestroy() {
    if (this.editableTabs.length) {
      localStorage.setItem(this.isCustomPage ? "config-editableTabs" : "editableTabs", JSON.stringify(this.editableTabs));
    } else {
      localStorage.removeItem(this.isCustomPage ? "config-editableTabs" : "editableTabs");
    }
    // 
    if (!isEmpty(this.dataWedgeApp)) {
      localStorage.setItem(this.isCustomPage ? "config-dataWedgeApp" : "dataWedgeApp", JSON.stringify(this.dataWedgeApp));
    } else {
      localStorage.removeItem(this.isCustomPage ? "config-dataWedgeApp" : "dataWedgeApp");
    }
    EventBus.$off('clearDWdata');
  },
};
</script>
